'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'newspaper';
var width = 512;
var height = 512;
var aliases = [128240];
var unicode = 'f1ea';
var svgPathData = 'M152 48c-22.1 0-40 17.9-40 40l0 336c0 15.7-6.4 29.8-16.8 40L440 464c30.9 0 56-25.1 56-56l0-320c0-22.1-17.9-40-40-40L152 48zM56 480c-30.9 0-56-25.1-56-56L0 192c0-35.3 28.7-64 64-64l0 16c-26.5 0-48 21.5-48 48l0 232c0 22.1 17.9 40 40 40s40-17.9 40-40L96 88c0-30.9 25.1-56 56-56l304 0c30.9 0 56 25.1 56 56l0 320c0 39.8-32.2 72-72 72L56 480zM352 104c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8zM160 296c0-4.4 3.6-8 8-8l272 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-272 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l272 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-272 0c-4.4 0-8-3.6-8-8zm24-248c-4.4 0-8 3.6-8 8l0 96c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-96c0-4.4-3.6-8-8-8l-112 0zm-24 8c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNewspaper = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;